var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58353 4.62484C5.58353 4.37067 5.6845 4.12692 5.86422 3.94719C6.04394 3.76747 6.2877 3.6665 6.54186 3.6665C6.79603 3.6665 7.03978 3.76747 7.21951 3.94719C7.39923 4.12692 7.5002 4.37067 7.5002 4.62484V8.90859L8.65978 9.03317L13.3939 11.1319C13.9019 11.3619 14.2085 11.8698 14.2085 12.4257V16.604C14.1798 17.3898 13.5569 18.0128 12.771 18.0415H6.54186C6.1777 18.0415 5.8327 17.8978 5.58353 17.6294L0.887695 13.6044L1.59686 12.8665C1.77895 12.6653 2.0377 12.5598 2.30603 12.5598H2.51686L5.58353 14.2082V4.62484ZM6.54186 0.791504C7.55853 0.791504 8.53355 1.19537 9.25244 1.91426C9.97133 2.63315 10.3752 3.60817 10.3752 4.62484C10.3752 6.06234 9.60853 7.27942 8.45853 7.94067V6.7715C9.04311 6.24442 9.41686 5.47775 9.41686 4.62484C9.41686 3.86234 9.11396 3.13107 8.57479 2.59191C8.03563 2.05274 7.30436 1.74984 6.54186 1.74984C5.77937 1.74984 5.0481 2.05274 4.50893 2.59191C3.96976 3.13107 3.66686 3.86234 3.66686 4.62484C3.66686 5.47775 4.04061 6.24442 4.6252 6.7715V7.94067C3.4752 7.27942 2.70853 6.06234 2.70853 4.62484C2.70853 3.60817 3.1124 2.63315 3.83129 1.91426C4.55018 1.19537 5.5252 0.791504 6.54186 0.791504Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionInactive);
export default __webpack_public_path__ + "static/media/actionInactive.b661a039affe469833f832f6c2ef6b57.svg";
export { ForwardRef as ReactComponent };